"use client";

import { Layout } from 'antd';
import styles from './Useful.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { LayersIcon } from '@/shared/constants/icon';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

const usefulData = [
  {
    id: 1,
    title: 'designers',
    desc: 'designersDesc',
  },
  {
    id: 2,
    title: 'photographers',
    desc: 'photographersDesc',
  },
  {
    id: 3,
    title: 'marketologists',
    desc: 'marketologistsDesc',
  },
  {
    id: 4,
    title: 'smmSpecialists',
    desc: 'smmSpecialistsDesc',
  },
  {
    id: 5,
    title: 'commerce',
    desc: 'commerceDesc',
  },
  {
    id: 6,
    title: 'blogs',
    desc: 'blogsDesc',
  },
];

export const Useful = () => {
  const t = useTranslations('textRemover.useful');

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title1')}</h1>
        <h1>— {t('title2')}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_items}>
        {usefulData.map((item) => (
          <section key={item.id} className={styles.root_items_item}>
            <LayersIcon color="var(--color-dark)" size={'1.5vw'} />
            <h2>{t(item.title)}</h2>
            <p>{t(item.desc)}</p>
          </section>
        ))}
      </ScrollReveal>
    </Content>
  );
};
